import script from "./BpmnModeler.vue?vue&type=script&setup=true&lang=ts"
export * from "./BpmnModeler.vue?vue&type=script&setup=true&lang=ts"

import "./BpmnModeler.vue?vue&type=style&index=0&id=4c60e95a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c60e95a"]])

export default __exports__